if (!customElements.get('hg-bundle-tabs')) {
  customElements.define('hg-bundle-tabs', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      else this.init();
    }
    init() {
      if (this.ready) return;
      this.ready = true;
      const list = this.querySelector('[role="tablist"]');
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (!list || tabs.length !== panels.length) return;
      const key = 'hg-bundle-tab:' + location.pathname + ':' + this.dataset.section;
      const activate = (index, focus = false) => {
        index = Math.max(0, Math.min(tabs.length - 1, Number(index) || 0));
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
        if (window.__fudgeDebug) { try { sessionStorage.setItem(key, String(index)); } catch (_) {} }
        return tabs[index].textContent.trim();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      list.hidden = false;
      let initial = 0;
      if (window.__fudgeDebug) { try { initial = Number(sessionStorage.getItem(key)) || 0; } catch (_) {} }
      activate(initial);
      /* Fudge debug controls — preview-only, no-ops live. See .skills/storefront/debug-ui.md */
      window.__fudgeDebug?.action('Anwendung anzeigen', () => { activate(0); this.scrollIntoView({ block: 'start' }); });
      window.__fudgeDebug?.action('FAQ anzeigen', () => { activate(1); this.scrollIntoView({ block: 'start' }); });
      window.__fudgeDebug?.command('Bundle-Reiter anzeigen', name => activate(name === 'FAQ' ? 1 : 0));
    }
  });
}
